import { Component, Input, Output, EventEmitter, ComponentFactoryResolver,
          ViewContainerRef, ViewChild,  Directive, ElementRef, OnChanges } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { Service } from '../org-vdc-wizard.service';
let $ = require('jquery');
import { AppState } from '../../../../../app.service';
import { NgForm } from '@angular/forms';
import { NgModule } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { SharedService } from '../shared-service';
import { StorageProfileCreateComponent } from './storage-profile-create.component';
const _ = require('lodash');

@Component({
  selector: 'storage-profile-create',
  template: require('./storage-profile-widget.html'),
  entryComponents: [StorageProfileCreateComponent],
  providers: [SharedService]
})
export class StorageProfileCreate {
  @Input() isEdit: boolean = false;
  @Input() orgVdcId: string = '';
  @Input() editData: any;
  @Input() isWizardOpen: boolean = false;
  @Input() selectedPVdcs: any;
  @Input() sddcStepData: any;
  @Output() storageProfileData: EventEmitter<any> = new EventEmitter();
  @ViewChild('widgetContainer', {read: ViewContainerRef}) widgetContainer;

  private arrSPData: Array<any> = [];
  private sService: SharedService;
  private sValues: any;
  private subscription: Subscription;
  private dataModel = {};
  private componentsArray: Array<any> = [];
  private isEditComponentLoaded: boolean = false;
  private isStorageProfileCreated: boolean = false;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private el: ElementRef,
              ss: SharedService ) {
    this.sService = ss;
  }

  ngOnInit() {
        this.subscription = this.sService.getEmittedValue()
        .subscribe (
          item => {
            this.sValues = item;
            this.handleEmittedValues(item);
          });
           this.addComponentNew();
    }

  ngOnChanges(changes) {
    if (!this.isWizardOpen) {
        this.componentsArray = [];
        $( '.sp-container .sp-component' ).remove();
        this.sService.resetData();
        this.isStorageProfileCreated = false;
        return;
    }
    
    if (this.sddcStepData) {
        this.updateSddcPool(this.sddcStepData);
    }
  }

    handleEmittedValues(item: any) {
      if (item.type === 'delete') {
          let templateID = item.data;
          for (let i = 0; i < this.componentsArray.length; i++) {
            if (this.componentsArray[i].instance.templateID === templateID) {
              this.componentsArray[i].destroy();
              this.componentsArray.splice(i, 1);
            }
          }
            this.storageProfileData.emit(this.dataModel);
      } else {
          this.dataModel = item.data;
          this.storageProfileData.emit(this.dataModel);
      }
  }
   updateSddcPool(sddcStepData) {
      $.each( this.componentsArray, function( key, value ) {
          value.instance.updateSddcPool(sddcStepData);
      });
  }
  addComponentNew() {
    const factory = this.componentFactoryResolver.resolveComponentFactory(StorageProfileCreateComponent);
    let component = this.widgetContainer.createComponent(factory);
    component.instance.templateID = this.getNextTemplateID(); //this.componentsArray.length;
    component.instance.thisComponent = component;
    component.instance.isWizardOpen = this.isWizardOpen;
    if (this.sddcStepData) {
        component.instance.updateSddcPool(this.sddcStepData);
    }
    this.componentsArray.push(component);
  }
  getNextTemplateID() {
      if (this.componentsArray.length === 0) {
          return 0;
      }

      let maxNo = 0;
      _.each(this.componentsArray, function(item) {
            let templateID = item._component.templateID;
            if (templateID > maxNo) {
                maxNo = templateID;
            }
       });
       return (maxNo + 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/storage-profile/storage-profile-create.ts